import {
  SearchableSelect,
  type SearchableSelectOption,
} from "@/core/components/ui/searchable-select";
import useTypedTranslation from "@/core/hooks/use-typed-translation";

/**
 * Select searchable pour une entité métier (party, wallet, merchant…).
 * Libellé humain + identifiant en `NoTranslate`. Les textes d’UI (recherche,
 * vide, chargement) viennent de l’i18n ; le placeholder reste à la charge
 * du champ appelant.
 */
export function EntitySearchableSelect({
  options,
  value,
  onValueChange,
  placeholder,
  isLoading,
  disabled,
  clearable,
  popoverWidth,
  id,
}: {
  options: SearchableSelectOption[];
  value?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
  clearable?: boolean;
  /** Voir `SearchableSelect.popoverWidth`. */
  popoverWidth?: "trigger" | "content";
  id?: string;
}) {
  const { t } = useTypedTranslation();
  return (
    <SearchableSelect
      id={id}
      options={options}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      searchPlaceholder={t("searchPlaceholder")}
      emptyMessage={t("emptyMessage")}
      loadingMessage={t("common.loading")}
      isLoading={isLoading}
      disabled={disabled}
      clearable={clearable}
      popoverWidth={popoverWidth}
      noTranslate
    />
  );
}

export type { SearchableSelectOption };
